import { EventEmitter, Injectable } from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BehaviorSubject } from "rxjs";
import {
  Benefits,
  SubscriptionFeatures,
  SubscriptionPlans,
  UserModel,
} from "src/app/services/userModel";
import { UtilService } from "src/app/services/util.service";
import { environment } from "src/environments/environment";
import Swal, { SweetAlertOptions, SweetAlertResult } from "sweetalert2";
import { ApiService } from "../../services/api.service";
import { PlanModel } from "./PlanModel";
import { ModelPriceComponent } from "./model-price/model-price.component";
import { CountProviderService } from "../../services/count-provider.service";
import { GigsumoConstants } from "src/app/services/GigsumoConstants";


export type BENEFITS_TYPES = {
  benefitKey?: BENEFITS_KEY,
  benefitDescription?: string,
  actual: number,
  utilized: number,
  available: number,
  payAsyouGo: number,
  promotional: number
}

export function getPlanBenefits(arr:Array<BENEFITS_TYPES> , KEY : BENEFITS_KEY) : BENEFITS_TYPES { 
  return arr.find(x => x.benefitKey === KEY) ?? 
  {  
    actual: 0,
    utilized: 0,
    available: 0,
    payAsyouGo: 0,
    promotional: 0
  };
}

export type BENEFITS_KEY =
  | "ACTIVE_INTERACTIONS"
  | "JOB_CANDIDATE_POSTINGS"
  | "B2B_NETWORKS"
  | "TEAM_WORKSPACES"
  | "PERSONAL_NETWORKS"
  | "UPGRADE_JOBS"
  | "UPGRADE_CANDIDATES"
  | "BUSINESS_NETWORKS_LISTING"
  | "BUSINESS_CONTACTS_LISTING"
  | "B2B_CONTACTS"
  | "INCLUDED_CONVERSATIONS"
  | "USERS"
  | "EDIT_B2B_NETWORKS"
  | "MANAGE_BUSINESS_CONTACT"
  | "MANAGE_BUSINESS_NETWORK"
  | "MANAGE_WORKSPACES"
  | "MANAGE_NETWORKS"
  | "ACTIVE_USERS"
  | "JOBS_CANDIDATE_SPOTLIGHTS"
  | "JOBS_CANDIDATE_ACTIVE_CREATIONS"  
  // | "JOBS_CANDIDATE_CREATIONS"  

export type BENEFITS_PLANS = {
  benefits: Benefits;
  subscriptionFeatures: SubscriptionFeatures;
  subscriptionPlans: SubscriptionPlans;
};

export type PayAsYouGoModel = {
  headerName: string;
  body: string;
};

export type ExpiryModel = {
  headerName: string;
  body: string;
  planDetail?: string;
  planMax?: string;
  slotsUsed?: string;
  availableProvision?: string;
  planExtensionSnippet?: string;
  planExtensionDetail1?: string;
  planExtensionDetail2?: string;
  planExtensionDetail3?: string;
  psNote?: string;
  promotional?: string;
  onboardheaderName?: string;
};

@Injectable({
  providedIn: "root",
})
export class PricePlanService {
  public lamdaurl: any = environment.LAMDA_URL;
  userPlan: PlanModel | undefined;
  featurelists: any;
  catagories: any;
  lists: any;
  sampleDate = "";
  ACTIVE_INTERACTION: number | undefined;
  PRICERESPONSE: any;
  // True while an exhaust/upgrade popup (ModelPriceComponent) is open — blocks a
  // second identical modal from stacking (e.g. rapid double-click on the status
  // toggle). Reset when the modal is dismissed. See expiredPopup().
  private expiredPopupOpen = false;

  readonly userType: string = localStorage.getItem("userType") || '';

  readonly swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: "btn btn-success",
      cancelButton: "btn btn-danger",
    },
    buttonsStyling: false,
  });

  plan: EventEmitter<any> = new EventEmitter<any>();
  userId: string | undefined;
  constructor(
    private api: ApiService,
    private util: UtilService,
    private provider: CountProviderService,
    private modalService: BsModalService
  ) {}

  // constructor(private API?: ApiService) {}

  async Plan_Features(): Promise<any> {
    let URL = this.lamdaurl + "findPlans";
    var myHeaders = new Headers();
    let requestOptions: any = {
      headers: myHeaders,
    };
    return await fetch(URL, requestOptions);
  }

  async getPlan_Features(): Promise<any> {
    return await this.Plan_Features()
      .then((result) => {
        return result.json();
      })
      .then((data) => {
        return data;
      });
  }

  isPayAsYouGo(val: BENEFITS_KEY): boolean {
    return (
      val === "ACTIVE_INTERACTIONS" ||
      val === "UPGRADE_CANDIDATES" ||
      val === "UPGRADE_JOBS"
    );
  }

  isJobseeker(): BehaviorSubject<any> {
    let userType = localStorage.getItem("userType");
    return new BehaviorSubject(userType || '');
  }

  async UPDATE_USERDETAILS(
    key: BENEFITS_KEY,
    keyvalue: boolean = false
  ): Promise<{ userDetail: any; isExpired: boolean; membershipType: string }> {
    try {

      if (this.isJobseeker().getValue() === "JOB_SEEKER") {
        return { userDetail: null, isExpired: false, membershipType: '' };
      }

      let userDetails: UserModel | any = await this.api.lamdaFunctionsget(
        "findUserPlanBenefits/" + localStorage.getItem("userId")
      );

      const {
        userPlanAndBenefits: { benefitsUsages: userBenefits, membershipType },
      } = userDetails.data;
      this.PRICERESPONSE = userDetails.data;

      if (userDetails.data) {
        this.provider.setBenefits(userDetails.data);
      }

      this.ACTIVE_INTERACTION = userBenefits.find(
        (ele: any) => ele.benefitKey === key
      ).available;

      if (keyvalue) {
        return {
          userDetail: userDetails.data,
          isExpired: userBenefits.find((ele: any) => ele.benefitKey === key)
            .available,
          membershipType,
        };
      } else {
        let available = userBenefits.find(
          (ele: any) => ele.benefitKey === key
        ).available;
        return {
          userDetail: userDetails.data,
          isExpired: available > 0 ? false : true,
          membershipType,
        };
      }
    } catch (error) {
      return { userDetail: null, isExpired: false, membershipType: '' };
    }
  }


  // Universal first-interaction check. Calls the message/contact/exist endpoint and
  // returns true when this JOB/CANDIDATE pair's interaction was ALREADY consumed
  // (an existing chat OR a prior apply/invite/resume-request — the backend
  // `alreadyConsumed` flag). Callers use it to SKIP the ACTIVE_INTERACTIONS gate
  // (findUserPlanBenefits/findPlans) on non-first interactions. Fails safe: returns
  // false (i.e. gate) on any error.
  async isInteractionAlreadyConsumed(refererId: string, groupType: string): Promise<boolean> {
    try {
      if (!refererId || !groupType) { return false; }
      const payload: any = {
        userId: localStorage.getItem("userId"),
        groupType: groupType,
        messageType: groupType,
        refererId: refererId,
      };
      const res: any = await this.api
        .messagePageService("POST", "message/contact/exist", payload)
        .toPromise();
      return !!(res && (res.alreadyConsumed === true || res.exist === true)) || false;
    } catch (e) {
      return false;
    }
  }

  // APPLICANTS MENU ONLY. When a job owner invites a candidate for a job, that invite
  // already consumes one ACTIVE_INTERACTION. The candidate then applies and shows up under
  // Applicants - and downloading their resume from there charged a SECOND interaction,
  // because `resumeDownloaded` only records downloads and knows nothing about the invite.
  //
  // The RESPONSE CODE carries the decision:
  //   00000 - an interestShownLogs row exists for this (candidate, job). The pair was already
  //           charged by the invite, so download straight away and skip the slot check.
  //   IS001 - no row. The caller must run the ACTIVE_INTERACTIONS validation
  //           (findUserPlanBenefits) and show the existing exhausted popup, which pulls the
  //           plan list from findPlans itself.
  //
  // Fails safe: a missing response, a 404 (endpoint not deployed yet) or any thrown error all
  // return false, which means "gate as normal" - never a free download because a lookup failed.
  async isInterestShownForJob(candidateId: string, jobId: string): Promise<boolean> {
    try {
      if (!candidateId || !jobId) { return false; }
      const res: any = await this.api
        .query(`candidates/interestShown/${candidateId}/${jobId}`)
        .toPromise();
      return res?.code === '00000';
    } catch (e) {
      return false;
    }
  }

  // return true if the user has available slots based on benefit keys
  // open expired popup based on KEYS and return false
  JobSeekerUpdate:any;
async checkUserPlanValid(KEY : BENEFITS_KEY , type : "FEATURED" | "JOBS_CANDIDATES" | "DEFAULT" = "DEFAULT", onUpgradePlanClick?: () => void) : Promise<boolean> {
    try {
      
          let userDetails: any = await this.api.lamdaFunctionsget("findUserPlanBenefits/" + localStorage.getItem("userId"));


          // if user is job seeker then return true
          // no need to check the plan and benefits for job seeker
          console.log("job seeker check", this.userType === "JOB_SEEKER");
          console.log("job seeker check",localStorage.getItem("userType") === "JOB_SEEKER");
          if (this.userType && this.userType === "JOB_SEEKER") { 
           //Jobseeker Update count check so am passing this values
            this.JobSeekerUpdate = userDetails.data;
            return true  
          }

          const { userPlanAndBenefits: { benefitsUsages: userBenefits, membershipType }} = userDetails.data; 
          let popupType: "PAY" | "LIMIT" | "UPGRADE" = "PAY";
          if (['Starter','Growth','ScaleX'].includes(membershipType)) {
            popupType = "LIMIT";
          }
          // Free-plan users get the same self-service "Not Enough" popup as
          // business plans for the Jobs/Candidate slots case (deactivate an
          // active job/candidate to free a slot, or upgrade) instead of the
          // static "Exhausted + Upgrade" PAY popup. Scoped to slots only.
          if (membershipType === 'Free' && KEY === 'JOB_CANDIDATE_POSTINGS') {
            popupType = "LIMIT";
          }
          
          let benefitData : BENEFITS_TYPES;
          benefitData = (userBenefits as BENEFITS_TYPES[]).
          find(x => x.benefitKey === KEY) || {
            actual: 0,
            utilized: 0,
            available: 0,
            payAsyouGo: 0,
            promotional: 0
          };

          console.log(`checking ${KEY} slots -->` , benefitData);

          if(benefitData.available > 0){
            return true;
          }
          else{
            // for featured no need to show the expired popup! so return false
            if(type === "FEATURED"){
              return false;
            }

            this.expiredPopup(KEY, popupType, null, null, null, null,
              String(benefitData.available), String(benefitData.actual), String(benefitData.utilized), String(benefitData.promotional), null, null, onUpgradePlanClick);
            return false;
          }

    } catch (error) {
        throw new Error("Exhausted popup intialization failed ===> " + error);
    } 
  }

  getRepsonseMessage(text: BENEFITS_KEY): Promise<SweetAlertResult> {
    switch (text) {
      case "ACTIVE_INTERACTIONS":
        return this.getSwal({
          text: "Your Active Interactions have gone below the limit(500) ",
          icon: "info",
          showConfirmButton: true,
          confirmButtonText: "Pay as you go",
        });
        break;
      case "JOB_CANDIDATE_POSTINGS":
        return this.getSwal({
          text: "you have exceeded the Limitation of creating Job / Candidates",
          icon: "info",
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonText: "Upgrade Plan",
          reverseButtons: true,
        });
        break;
      case "PERSONAL_NETWORKS":
        return this.getSwal({
          text: "you have exceeded the Limitation of creating Networks",
          icon: "info",
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonText: "Upgrade Plan",
          reverseButtons: true,
        });
        break;
      case "TEAM_WORKSPACES":
        return this.getSwal({
          text: "you have exceeded the Limitation of creating Workspace",
          icon: "info",
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonText: "Upgrade Plan",
          reverseButtons: true,
        });
        break;
      default:
        return Promise.resolve({} as SweetAlertResult);
    }
  }

  private getSwal(options: SweetAlertOptions) {
    return this.swalWithBootstrapButtons.fire(options);
  }

  expiredPopup(
    val?: BENEFITS_KEY,
    modelname: "UPGRADE" | "PAY" | "LIMIT" = "PAY",
    jobData = null,
    currenttimezonedate = null,
    currentDates = null,
    alertdate = null,
    availablecredits: string | null = null,
    actualcredits: string | null = null,
    utilizedcredits: string | null = null,
    promotional: string | null = null,
    limitInfo = null,
    availablePostingsSlot = null,
    onUpgradePlanClick?: () => void
  ): void {
    // Guard against stacking duplicate exhaust/upgrade popups. ngx-bootstrap
    // modals stack on repeated show() calls, so a rapid double-click on the
    // Active/Available status toggle — which fires checkUserPlanValid() ->
    // expiredPopup() twice — opened two identical modals. Ignore a second open
    // while one is already showing; the flag is cleared when it's dismissed.
    if (this.expiredPopupOpen) {
      // Self-heal before trusting the flag. It is only cleared from the popup's own
      // ngOnDestroy, so any close path that hides the popup WITHOUT destroying it
      // leaves it stuck at true. Because this service is a root singleton, one stuck
      // flag silently disabled every slot-gated action - Invite, Apply, Chat,
      // Download Resume, Resume Request - for the rest of the session: the popup
      // showed once and every later click did nothing.
      //
      // If the flag says "open" but no price popup is actually in the DOM, it is
      // stale, so clear it and carry on. When the popup genuinely is showing (or
      // still animating out) the element is present and the duplicate-open guard
      // still holds, which is what the flag exists for.
      if (document.querySelector('app-model-price')) { return; }
      this.expiredPopupOpen = false;
    }
    this.expiredPopupOpen = true;

    const initialState: any = {
      backdrop: "static",
      keyboard: false,
      size: "open",
      content: val,
      ModelContent: this.getTextBasedOnKey(val, modelname),
      modalName: modelname,
      upgradeDetails: jobData,
      currentdate: currenttimezonedate,
      featureddate: currentDates,
      alertdate : alertdate ,
      availablecredits: availablecredits,
      actualcredits: actualcredits,
      utilizedcredits: utilizedcredits,
      promotional: promotional,
      limitInfo: limitInfo,
      availablePostingsSlot: availablePostingsSlot,
      // Reset the guard from the popup's OWN ngOnDestroy (see ModelPriceComponent).
      // Previously this was cleared on the global modalService.onHidden, which
      // fires for ANY modal closing — including the Edit form open underneath
      // this popup — so the guard dropped while the popup was still on screen and
      // a rapid second toggle click stacked a duplicate "Not Enough Slots" modal.
      onExhaustPopupDestroyed: () => { this.expiredPopupOpen = false; },
      onUpgradePlanClick: onUpgradePlanClick
    };
    // ONE modal. ModelPriceComponent now renders the exhaust/upgrade template
    // directly inside this container (see its *ngTemplateOutlet) — it no longer
    // opens a second inner modal in ngOnInit. Previously this container was an
    // empty CSS-hidden "host" (gs-modal-host-hidden) whose only job was to spawn
    // the visible modal, so every popup was two stacked <modal-container>s that
    // tore down on different timers and looked like "two popup screens closing".
    // Rendering inline collapses it to one modal + one static backdrop + one
    // clean close for both the × and the Close button.
    this.modalService.show(ModelPriceComponent, {
      initialState,
      backdrop: 'static',
      keyboard: false,
      ignoreBackdropClick: true
    });
    // Guard is reset by ModelPriceComponent.ngOnDestroy via `onExhaustPopupDestroyed`
    // in initialState above — tied to THIS popup's teardown, not a global hide event.
  }

  getTextBasedOnKey(
    key: BENEFITS_KEY,
    modelName: "UPGRADE" | "PAY" | "LIMIT"
  ): ExpiryModel {
    if (["PAY", "LIMIT"].includes(modelName)) {
      switch (key) { 
        case "ACTIVE_INTERACTIONS":
          return {
            headerName: "Interaction Credits ",
            onboardheaderName: "Interaction Credits Prerequisites",
            body: "Interaction credits available for this plan:",
            planMax: "Plan Max",
            slotsUsed: "Used",
            promotional: "Promotional",
            availableProvision: "Available",
            planExtensionSnippet:
              "To increase your interaction limits, you can exercise one of the below options.",
            planExtensionDetail1: '1. Upgrade to "Starter" subscription.',
            planExtensionDetail2:
              "2. Contact support to add additional interaction credits.",
            psNote: "*interaction credits will reset on the 1st of each month.",
          };
          break;
        case "JOB_CANDIDATE_POSTINGS":
          return {
            headerName: "Jobs / Candidate Slots ",
            onboardheaderName: "Jobs / Candidate Creation Prerequisites",
            body: "You are currently on the",
            planDetail: "Job/ candidate slots available for this plan is,",
            planMax: "Plan Max",
            slotsUsed: "Slots Used",
            promotional: "Promotional",
            availableProvision: "Available",
            planExtensionSnippet:
              "To post additional jobs/ candidates, you can exercise one of the below options.",
            planExtensionDetail1: '1. Upgrade to "Starter" subscription.',
            planExtensionDetail2:
              "2. Deactivate one of the active jobs/ candidates and post a new one.",
            planExtensionDetail3: "3. Contact support to add additional slots.",
          };
          break;
        case "JOBS_CANDIDATE_ACTIVE_CREATIONS":
          return {
            headerName: "Jobs/Candidate posting Slots ",
            onboardheaderName: "Jobs / Candidate Creation Prerequisites",
            body: "You are currently on the",
            planDetail: "Job/ candidate posting slots available for this plan is,",
            planMax: "Plan Max",
            slotsUsed: "Slots Used",
            promotional: "Promotional",
            availableProvision: "Available",
            planExtensionSnippet:
              "To post additional jobs/ candidates, you can exercise one of the below options.",
            planExtensionDetail1: '1. Upgrade to "Starter" subscription.', 
            planExtensionDetail3: "3. Contact support to add additional slots.",
          };
          break;
        case "PERSONAL_NETWORKS":
          return {
            headerName: "Networks Limit ",
            onboardheaderName: "Network Prerequisites",
            body: "You are currently on the",
            planDetail: "Network credits available for this plan:",
            planMax: "Plan Max",
            slotsUsed: "Used",
            promotional: "Promotional",
            availableProvision: "Available",
            psNote:
              "*if you need additional networks, consider upgrading to higher plan.",
          };
          break;
        case "TEAM_WORKSPACES":
          return {
            headerName: "Workspace Credits ",
            onboardheaderName: "Workspace Credits Prerequisites",
            body: "You are currently on the",
            planDetail: "Workspace credits available for this plan:",
            planMax: "Plan Max",
            slotsUsed: "Used",
            promotional: "Promotional",
            availableProvision: "Available",
            psNote:
              "*if you need additional workspace credits, consider upgrading to higher plan.",
          };
          break;

          case "ACTIVE_USERS":
          return {
            headerName: "User Limit",
            onboardheaderName: "User Limit Prerequisites",
            body: "You are currently on the",
            planDetail: "User Limit available for this plan:",
            planMax: "Plan Max",
            slotsUsed: "Used",
            promotional: "Promotional",
            availableProvision: "Available",
            psNote:
              "*if you need additional User Limit, consider upgrading to higher plan.",
          };
          break;

        case "INCLUDED_CONVERSATIONS":
          return {
            headerName: "Members Limit",
            onboardheaderName: "Member Prerequisites",
            body: "You are currently on the",
            planDetail: "Member credits available for this plan:",
            planMax: "Plan Max",
            slotsUsed: "Used",
            promotional: "Promotional",
            availableProvision: "Available",
            psNote:
              `*if you need additional Members, consider upgrading to higher plan. <br>
               *if you need more contacts, you can purchase the feature from the Top-up section. <br>
               *if you remove or cancel a contact, you will be able to create new contacts.`,
          };
          break;
        case "B2B_CONTACTS":
          return {
            headerName: "Business Contacts Limit",
            onboardheaderName: "Business Contacts Prerequisites",
            body: "You are currently on the",
            planDetail: "Business Contact credits available for this plan:",
            planMax: "Plan Max",
            slotsUsed: "Used",
            promotional: "Promotional",
            availableProvision: "Available",
            psNote:
              `*if you need additional  Business Contacts, consider upgrading to higher plan. <br>
               *if you need more contacts, you can purchase the feature from the Top-up section. <br>
               *if you remove or cancel a contact, you will be able to create new contacts.`,
          };
          break;
          case "B2B_NETWORKS":
            return {
              headerName: "Business Networks Limit",
              onboardheaderName: "Business Networks Prerequisites",
              body: "You are currently on the",
              planDetail: "Business Network credits available for this plan:",
              planMax: "Plan Max",
              slotsUsed: "Used",
              promotional: "Promotional",
              availableProvision: "Available",
              psNote:
                "*if you need additional Business Networks, consider upgrading to higher plan.",
            };
            break;


        default:
          break;
      }
    } else {
      switch (key) {
        case "UPGRADE_JOBS":
          return {
            headerName: "Upgrade Job",
            body: "*Upgrade job consumes 25 Sumo credits per day.",
          };
          break;
        case "UPGRADE_CANDIDATES":
          return {
            headerName: "Upgrade Candidate",
            body: "*Upgrade candidate consumes 25 Sumo credits per day.",
          };
          break;
        // case "RESUME_VIEWS":
        //   return {
        //     headerName: 'Add Resume Views',
        //     body: '*Resume views consumes 5 Sumo credits per view.'
        //   }
        //   break;
        case "ACTIVE_INTERACTIONS":
          return {
            headerName: "Add Active Interactions",
            body: "*Interactions consumes 5 Sumo credits per active interaction.",
          };
          break;
        default:
          break;
      }
    }
  }
}
